import { Leaf } from "lucide-react";

export const Logo = ({ dark = false, className = "" }) => {
  const textColor = dark ? "text-white" : "text-forest";
  const subColor = dark ? "text-lime-bright" : "text-forest-600";
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="site-logo">
      <div
        className={`flex h-10 w-10 items-center justify-center rounded-md ${
          dark ? "bg-lime-bright" : "bg-forest"
        }`}
      >
        <Leaf className={dark ? "text-forest" : "text-lime-bright"} size={22} strokeWidth={2} />
      </div>
      <div className="leading-none">
        <div className={`font-heading text-base font-extrabold tracking-tight ${textColor}`}>
          FRONTIERS INFRA
        </div>
        <div className={`font-heading text-[10px] font-medium uppercase tracking-[0.2em] ${subColor}`}>
          Sustainability Consortium
        </div>
      </div>
    </div>
  );
};
